/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuthCallBackLineResponse } from "./AuthCallBackLineResponse";

export type AuthCallBackLineResponseApiRespoonse = {
  data?: AuthCallBackLineResponse;
  status?: AuthCallBackLineResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace AuthCallBackLineResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
